<template style="border:0px;">
  <div>
    <api-manager />
  </div>
</template>

<script>
import ApiManager from '@/components/ApiManager'

export default {
  name: 'LayoutComponentApiManager',
components: {
    ApiManager,
  },
  props: {
    component: {
      type: Object,
      default: undefined,
    },
    modules: {
      type: Object,
      default: undefined,
    },
  },
  data () {
    return {
      manyErrors: false,
    }
  },
  computed: {

  },
    watch: {

},
  created () {

  },
  mounted () {

  },
  methods: {

  },
}

</script>

<style scoped>

</style>
